import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "./api";

const AuthContext = createContext(null);
const TOKEN_KEY = "padel_token";

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const applyToken = (token) => {
    if (token) {
      localStorage.setItem(TOKEN_KEY, token);
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
      localStorage.removeItem(TOKEN_KEY);
      delete axios.defaults.headers.common["Authorization"];
    }
  };

  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) { setLoading(false); return; }
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    axios.get(`${API}/auth/me`)
      .then((r) => setUser(r.data))
      .catch(() => applyToken(null))
      .finally(() => setLoading(false));
  }, []);

  const register = async (username, password, securityQuestion, securityAnswer) => {
    const { data } = await axios.post(`${API}/auth/register`, {
      username, password, security_question: securityQuestion, security_answer: securityAnswer,
    });
    applyToken(data.token);
    setUser(data.user);
  };

  const login = async (username, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { username, password });
    applyToken(data.token);
    setUser(data.user);
  };

  const resetPassword = async (username, securityAnswer, newPassword) => {
    const { data } = await axios.post(`${API}/auth/reset/confirm`, {
      username, security_answer: securityAnswer, new_password: newPassword,
    });
    applyToken(data.token);
    setUser(data.user);
  };

  const logout = () => { applyToken(null); setUser(null); };
  const updateUser = (patch) => setUser((u) => ({ ...u, ...patch }));

  return (
    <AuthContext.Provider value={{ user, loading, register, login, resetPassword, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
